module.exports = __webpack_public_path__ + "img/misha1.2b4e06da.jpg";